import React, {useEffect} from 'react';
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {useParams} from "react-router-dom";
import apiClient from "../../utils/api";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";


function Migration({migration}: { migration: never }) {
    const changes = []
    migration.tables.forEach((tableChange) => {
        tableChange.column_changes.forEach((change) => {
            changes.push(
                <tr key={change.column_id}>
                    <td>{tableChange.table_name}.{change.column_name}</td>
                    <td>{change.change_type}</td>
                </tr>
            )
        })
    })
    return <>
        <h3>{changes.length} changes at {migration.created_at}</h3>
        <table>
            <thead>
            <tr>
                <th>Column Name</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {changes}
            </tbody>
        </table>
    </>
}

function MigrationsList(props: { schemaChanges: never }) {
    const migrations = []
    let migration_id = 0
    props.schemaChanges.forEach((migration) => {
        migrations.push(<Migration migration={migration} key={migration_id}/>)
        migration_id++
    })
    return <>
        {migrations}
    </>
}

function DatabaseSchemaChanges() {
    const {id} = useParams()
    const [schemaChanges, setSchemaChanges] = React.useState(null)

    useEffect(() => {
        apiClient.getSchemaChanges(id).then((data) => {
            setSchemaChanges(data)
        })
    }, []);

    if(schemaChanges === null) {
        return <LoadingLayout />
    }

    let content = null;
    if (schemaChanges.length === 0) {
        content = <>
            <div>No schema changes have been made yet.</div>
        </>
    } else {
        content = <MigrationsList schemaChanges={schemaChanges} />
    }

    return <FullWidthLayout
        title={`Database:`}
        mainContent={content}
        actionButton={null}
    />
}

export default DatabaseSchemaChanges;